import {
  ToolbarSeparator,
  ToolbarToggleButtonGroup,
  ToolbarToggleButtonGroupItem,
} from "@prismicio/editor-ui"
import type { Editor } from "@tiptap/core"

import type { MenuItem } from "../models/MenuItems"

interface MarkItemsProps {
  items: MenuItem[]
  editor: Editor
}

export function MarkItems(props: MarkItemsProps) {
  const { items, editor } = props

  if (items.length === 0) return null

  return (
    <>
      <ToolbarSeparator />
      <ToolbarToggleButtonGroup
        key="mark"
        onValueChange={(value) => {
          items.forEach((item) => {
            if (
              (item.isActive(editor) && !value.includes(item.nodeType)) ||
              (!item.isActive(editor) && value.includes(item.nodeType))
            ) {
              item.runCommands(editor)
            }
          })
        }}
        type="multiple"
        value={items
          .filter((item) => item.isActive(editor))
          .map((item) => item.nodeType)}
      >
        {items.map((item) => (
          <ToolbarToggleButtonGroupItem
            disabled={!item.runCommands(editor, { can: true })}
            key={item.nodeType}
            startIcon={item.icon}
            value={item.nodeType}
          />
        ))}
      </ToolbarToggleButtonGroup>
    </>
  )
}
